module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADHRSTlMAMPAQ0ECggCBgwHDygf0nAAAA0UlEQVQoz7WRPQrCQBCFJ4h/aBFsBDsrG4sVvIAINqax2N7CMkewsMktcpogCvIO5QzZ/EzGTn3V5vHtfsOEfpkN2SywMl20Bs7dcgbg8QFk1IBHRrvg3eWCanBPY+Bp1TkKq54AsVFvgVsbPDDaS/DS6hS4AEutHoBTxAokSmFAYtSCrLYgq/8AzlFtKWnAKTjyEbVe5LJcSB+oXxyG61I26sx7F0qtDmUAdWlAsZd7FEs9p5wElHmqOSmAoQw/7iqnHZG6PvLen+SQeYmjb/MGxsuv+ir308MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/el_msg_icon_white_answer.png
// module id = GZon
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82